import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-contactez-nous',
  templateUrl: './contactez-nous.component.html',
  styleUrls: ['./contactez-nous.component.scss']
})
export class ContactezNousComponent implements OnInit {
  
  currentStep: number = 1;
  submissionSuccess: boolean = false;
  submissionError: string = '';
  isSubmitting: boolean = false;
  currentYear = new Date().getFullYear();
  
  // Country codes for phone numbers
  countryCodes = [
    { code: '+33', country: 'France', flag: '🇫🇷' },
    { code: '+212', country: 'Maroc', flag: '🇲🇦' }
  ];
  selectedCountryCode = this.countryCodes[0]; // Default to France
  showCountryDropdown = false;

  
  formData = {
    name: '',
    email: '',
    company: '',
    employeeCount: '',
    phone: '',
    services: {
      webSite: false,
      seo: false,
      advertising: false,
      socialMedia: false,
      design: false,
      photo: false,
      copywriting: false,
      global: false,
      development: false
    },
    budget: '',
    subject: '',
    details: '',
    acceptTerms: false
  };

  constructor() { }

  ngOnInit(): void {
  }
  
  nextStep(): void {
    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }
  
  previousStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }
  
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
  hasSelectedServices(): boolean {
    return Object.values(this.formData.services).some(value => value === true);
  }
  
  onSubmit(): void {
    if (!this.formData.acceptTerms || !this.formData.subject) {
      this.submissionError = 'Veuillez remplir tous les champs obligatoires.';
      return;
    }
    
    this.isSubmitting = true;
    this.submissionError = '';
    
    // Simulate API call
    setTimeout(() => {
      // Here you would normally send the data to your backend
      console.log('Form Data:', this.formData);
      
      this.isSubmitting = false;
      this.submissionSuccess = true;
      
      // Scroll to top to show success message
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 2000);
  }
  
  resetForm(): void {
    this.currentStep = 1;
    this.submissionSuccess = false;
    this.submissionError = '';
    this.isSubmitting = false;
    this.selectedCountryCode = this.countryCodes[0]; // Reset to France
    this.showCountryDropdown = false;
    
    this.formData = {
      name: '',
      email: '',
      company: '',
      employeeCount: '',
      phone: '',
      services: {
        webSite: false,
        seo: false,
        advertising: false,
        socialMedia: false,
        design: false,
        photo: false,
        copywriting: false,
        global: false,
        development: false
      },
      budget: '',
      subject: '',
      details: '',
      acceptTerms: false
    };
  }
  
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  
  toggleCountryDropdown(): void {
    this.showCountryDropdown = !this.showCountryDropdown;
  }
  
  selectCountryCode(country: any): void {
    this.selectedCountryCode = country;
    this.showCountryDropdown = false;
  }
  
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.country-code-selector');
    
    if (!clickedInside && this.showCountryDropdown) {
      this.showCountryDropdown = false;
    }
  }
}